module.exports = __webpack_public_path__ + "spa-static/img/viber.304070b9.svg";